import {
    SistemaRecurso,
    StockPersonalENTITY,
    TuvesENTITY,
    EquipoLogisticaDTO,
    ItemENTITY,
    MaterialeswinDTO,
} from 'sigo-entities'
import {
    useFindOneStockPersonalEquiposMutation,
    useFindStockPersonalMutation
} from "../../shared/Infraestructure/SliceLogistica"
import { ViewLoading } from "../../shared/Components/ViewLoading"
import { ViewError } from "../../shared/Components/ViewError"
import { Children, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { RootState } from "../../shared/Infraestructure/AdapterStore"
import { Formik, FormikHelpers } from "formik"
import * as yup from 'yup'
import { DtoValueOnSelect, IDataEquipos } from "../../shared/Domain"
import { Button, Col, Form, Row, Spinner } from "react-bootstrap"
import { InputNumber } from "../../shared/Components/ReactBootstrap/InputNumber/InputNumber"
import { InputSelect, InputText } from "../../shared/Components/ElementInputsCostume"
import { AdapterGenerico } from "../../shared/Infraestructure/AdapterGenerico"
import {
    useAddInventoryTuvesOrdersMutation,
    useDeleteInventoryTuvesOrdersMutation,
    useLazyGetTransitTuvesOrdersQuery
} from "../../shared/Infraestructure/slice"

interface IProps {
    row: TuvesENTITY,
    dataItems: ItemENTITY[]
}

interface IBody {
    ID_StockPersonal: number,
    cantidad: number,
    Serie?: {
        Serie: string,
        ID_StockPersonalEquipos: number
    }
    SerieDeinstall?: {
        Serie: string,
        Codigo: string
        Descripcion: string
    }
}

export function AddInventory(props: IProps) {
    const { row, dataItems } = props
    const [findStockPersonal, { data, isLoading, isError, error }] = useFindStockPersonalMutation()
    const [
        findStockPersonalEquipos,
        { data: dataEquipos, isLoading: isLoadingEquipos, isError: isErrorEquipos, error: errorEquipos }
    ] = useFindOneStockPersonalEquiposMutation()
    const [
        getTransitTuvesOrdersQuery,
        { isFetching: isFetchingTransit, isError: isErrorTransit, error: errorTransit }
    ] = useLazyGetTransitTuvesOrdersQuery()
    const { user, personal } = useSelector((state: RootState) => state.auth)
    const [addInventory, { isLoading: isLoadingAddInventory }] = useAddInventoryTuvesOrdersMutation()
    const [deleteInventory, { isLoading: isLoadingDeleteInventory }] = useDeleteInventoryTuvesOrdersMutation()
    const [equipos, setEquipos] = useState<IDataEquipos[]>([])

    const initialValues = {
        material: new DtoValueOnSelect<StockPersonalENTITY>(),
        equipo: new DtoValueOnSelect<EquipoLogisticaDTO>(),
        item: new DtoValueOnSelect<ItemENTITY>(),
        disponible: 0,
        cantidad: 0,
        serialDeinstall: '',
    }

    type InitialValues = typeof initialValues

    const schema = yup.object().shape({
        material: yup
            .object()
            .shape({ value: yup.string().min(1, 'Seleccione una opción') }),
        equipo: yup
            .object()
            .test({
                test(value, ctx) {
                    if (
                        this.parent.material?.dataComplete?.Item?.Ind_SB === 'S' &&
                        value.value === ''
                    ) {
                        return ctx.createError({
                            path: `${ctx.path}.value`,
                            message: 'Seleccione un equipo',
                        })
                    }
                    return true
                }
            }),
        cantidad: yup.number()
            .required('Campo es requerido')
            .min(1, 'El valor mínimo es 1')
            .test({
                test(value, ctx) {
                    if (value === undefined) return true
                    if (this.options.context?.material?.value) {
                        const disponible = this.options.context?.disponible
                        if (value > disponible) {
                            return ctx.createError({ message: `Cantidad supera lo disponible` })
                        }
                    }
                    return true
                }
            }),
        disponible: yup.number().required('Campo es requerido'),
        item: yup
            .object()
            .test({
                test(value, ctx) {
                    if (
                        this.parent.material?.dataComplete?.Item?.Ind_SB === 'S' &&
                        row.subtipo_de_actividad === 'Reclamo' &&
                        value.value === ''
                    ) {
                        return ctx.createError({
                            path: `${ctx.path}.value`,
                            message: 'Seleccione un material',
                        })
                    }
                    return true
                }
            }),
        serialDeinstall: yup.string()
            .test({
                test(value = '', ctx) {
                    if (
                        this.parent.material?.dataComplete?.Item?.Ind_SB === 'S' &&
                        row.subtipo_de_actividad === 'Reclamo' &&
                        value.length < 1
                    ) {
                        return ctx.createError({ message: `¡Debe ingresar una serie!` })
                    }
                    return true
                }
            }),
    })

    const getDataStockPersonal = async () => {
        try {
            const pipeline = [{
                $match: {
                    'Personal.Identificacion': user.Identificacion,
                    'TipoStock.Nombre': 'NUEVO',
                    FlagPex: 0,
                    'Estado.ID_Estado': 2,
                    'Item.GranFamiliaItem.Nombre': { $in: ['MATERIAL TUVES'] },
                }
            }]
            await findStockPersonal({ pipeline, delegacion: user.Delegacion.Codigo, pais: user.Pais.Codigo }).unwrap()
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    useEffect(() => {
        if (row._id) {
            getDataStockPersonal()
        }
    }, [row])

    useEffect(() => {
        if (dataEquipos) {
            setEquipos(AdapterGenerico.orderEquiposByFecha(dataEquipos.Equipos))
        }
    }, [dataEquipos])

    const onSubmitForm = async (
        values: InitialValues,
        formikHelpers: FormikHelpers<InitialValues>
    ) => {
        try {
            const body: IBody = {
                ID_StockPersonal: values.material.dataComplete.ID_StockPersonal,
                cantidad: values.cantidad,
            }
            if (values.material.dataComplete.Item.Ind_SB === 'S') {
                body.Serie = {
                    Serie: values.equipo.dataComplete.Serie,
                    ID_StockPersonalEquipos: dataEquipos?.ID_StockPersonalEquipos ?? 0
                }
                if (row.subtipo_de_actividad === 'Reclamo') {
                    body.SerieDeinstall = {
                        Serie: values.serialDeinstall,
                        Codigo: values.item.dataComplete.Codigo,
                        Descripcion: values.item.dataComplete.Descripcion,
                    }
                }
            }
            await addInventory({ body, id: row._id }).unwrap()
            formikHelpers.resetForm()
            AdapterGenerico.createMessage('Información', '¡Agregado!', 'success')
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    const onDeleteMaterial = async (e: MaterialeswinDTO) => {
        try {
            await deleteInventory({ id: row._id, codigo: e.ID_StockPersonal, serie: e.invsn }).unwrap()
            AdapterGenerico.createMessage('Información', 'Eliminado!', 'success')
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    if (isLoading) return <ViewLoading />
    if (isError || isErrorTransit || isErrorEquipos) return <ViewError error={error || errorTransit || errorEquipos} />

    return (
        <Formik
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={onSubmitForm}
        >
            {
                ({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => {
                    return (
                        <Form
                            className='d-flex flex-column gap-2 justify-content-between'
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <div>
                                <Row>
                                    <InputSelect
                                        label='Material'
                                        name='material'
                                        onChange={async (name, value: DtoValueOnSelect<StockPersonalENTITY>) => {
                                            try {
                                                const idrecurso = personal?.RecursosPersonal.find(e => e.Sistema === SistemaRecurso.TUVE)
                                                if (!idrecurso) throw new Error(`¡No se pudo obtener id recurso!`)

                                                const { transito } = await getTransitTuvesOrdersQuery({
                                                    codigo: value.dataComplete.ID_StockPersonal,
                                                    id_recurso: idrecurso.IdRecurso
                                                }).unwrap()

                                                const { Despacho, Devolucion, Liquidacion } = value.dataComplete
                                                const disponible = Despacho - Devolucion - Liquidacion - transito
                                                await setFieldValue('disponible', disponible)

                                                handleChange({ target: { value, name } })
                                                if (value.dataComplete.Item.Ind_SB === 'S') {
                                                    const arg = {
                                                        pais: user.Pais.Codigo,
                                                        delegacion: user.Delegacion.Codigo,
                                                        pipeline: [
                                                            {
                                                                $match: {
                                                                    CodigoLlave: value.dataComplete.CodigoLlave,
                                                                    CodigoBusqueda: value.dataComplete.CodigoBusqueda,
                                                                    Identificacion: value.dataComplete.Personal.Identificacion,
                                                                    ID_StockPersonal: value.dataComplete.ID_StockPersonal,
                                                                }
                                                            },
                                                            {
                                                                $addFields: {
                                                                    Equipos: {
                                                                        $filter: {
                                                                            input: '$Equipos',
                                                                            as: 'equipo',
                                                                            cond: { $eq: ['$$equipo.Estado.ID_Estado', 2] }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                    await findStockPersonalEquipos(arg).unwrap()
                                                    await setFieldValue('cantidad', 1)
                                                } else {
                                                    await setFieldValue('equipo', new DtoValueOnSelect<EquipoLogisticaDTO>())
                                                    await setFieldValue('cantidad', 0)
                                                }
                                                handleChange({ target: { value, name } })
                                            } catch (error) {
                                                console.error(error)
                                                AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                                            }
                                        }}
                                        values={values}
                                        isRequired
                                        options={(data ?? []).map(el => ({
                                            label: `${el.Item.Codigo} - ${el.Item.Nombre}${el.Lote ? ` - Lt: ${el.Lote}` : ''}`,
                                            value: el.ID_StockPersonal,
                                            dataComplete: el
                                        }))}
                                        loading={isFetchingTransit || isLoadingEquipos}
                                        disabled={isFetchingTransit || isLoadingEquipos}
                                        disabledVirtualized
                                        errors={errors}
                                        touched={touched}
                                    />
                                </Row>
                                {
                                    values.material?.dataComplete?.Item?.Ind_SB === 'S'
                                        ? (
                                            <Row>
                                                <InputSelect
                                                    label='Equipo'
                                                    name='equipo'
                                                    onChange={(name, value: DtoValueOnSelect<EquipoLogisticaDTO>) => {
                                                        try {
                                                            handleChange({ target: { value, name } })
                                                        } catch (error) {
                                                            console.error(error)
                                                            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                                                        }
                                                    }}
                                                    values={values}
                                                    isRequired
                                                    options={equipos}
                                                    loading={isLoadingEquipos || isFetchingTransit}
                                                    disabled={isLoadingEquipos || isFetchingTransit}
                                                    disabledVirtualized
                                                    errors={errors}
                                                    touched={touched}
                                                />
                                            </Row>
                                        )
                                        : null
                                }
                                <Row>
                                    <Col >
                                        <InputNumber
                                            label='Disponible'
                                            name='disponible'
                                            errors={errors}
                                            touched={touched}
                                            values={values}
                                            handleChange={handleChange}
                                            type='number'
                                            readOnly
                                        />
                                    </Col>
                                    <Col>
                                        <InputNumber
                                            label='Cantidad'
                                            name='cantidad'
                                            errors={errors}
                                            touched={touched}
                                            values={values}
                                            handleChange={handleChange}
                                            required
                                            type='number'
                                            disabled={values.material?.dataComplete?.Item?.Ind_SB === 'S'}
                                        />
                                    </Col>
                                </Row>
                                {
                                    values.material?.dataComplete?.Item?.Ind_SB === 'S' &&
                                        row.subtipo_de_actividad === 'Reclamo'
                                        ? <>
                                            <Row>
                                                <InputSelect
                                                    label='Producto'
                                                    name='item'
                                                    onChange={(name, value: DtoValueOnSelect<ItemENTITY>) => {
                                                        try {
                                                            handleChange({ target: { value, name } })
                                                        } catch (error) {
                                                            console.error(error)
                                                            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
                                                        }
                                                    }}
                                                    values={values}
                                                    isRequired
                                                    options={dataItems.map(el => ({
                                                        label: `${el.Codigo} - ${el.Descripcion}`,
                                                        value: el.Codigo,
                                                        dataComplete: el
                                                    }))}
                                                    disabled={isLoadingEquipos || isFetchingTransit}
                                                    disabledVirtualized
                                                    errors={errors}
                                                    touched={touched}
                                                />
                                            </Row>
                                            <Row>
                                                <InputNumber
                                                    type='text'
                                                    label='Serie'
                                                    name='serialDeinstall'
                                                    errors={errors}
                                                    touched={touched}
                                                    values={values}
                                                    handleChange={handleChange}
                                                    required
                                                />
                                            </Row>
                                        </>
                                        : null
                                }
                            </div>
                            <Row>
                                <Col>
                                    <Button
                                        className='w-100'
                                        disabled={isLoadingAddInventory}
                                        type='submit'
                                    >
                                        {isLoadingAddInventory ? 'Cargando…' : 'GUARDAR'}
                                    </Button>
                                </Col>
                            </Row>
                            <table className='table table-striped' style={{ backgroundColor: 'gray' }}>
                                <thead>
                                    <tr>
                                        <th scope='col'>Código</th>
                                        <th scope='col'>Descripción</th>
                                        <th scope='col' className='text-center'>Cantidad</th>
                                        <th scope='col' className='text-center'>Tipo</th>
                                        <th scope='col' className='text-center'>Serie</th>
                                        <th scope='col' style={{ textAlign: 'center' }}>x</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        Children.toArray(
                                            row.inventory.map(e =>
                                                <tr>
                                                    <td>{e.codigo}</td>
                                                    <td>{e.descripcion}</td>
                                                    <td className='text-center'>{e.cantidad.toFixed(2)}</td>
                                                    <td className='text-center'>{e.invpool}</td>
                                                    <td className='text-center'>{e.invsn}</td>
                                                    <td
                                                        scope='row'
                                                        onClick={() => onDeleteMaterial(e)}
                                                        style={{ verticalAlign: 'middle', textAlign: 'center' }}
                                                    >
                                                        {
                                                            isLoadingDeleteInventory ? (
                                                                <Spinner animation='border' size='sm' />
                                                            ) : (
                                                                <i className='fa-solid fa-trash' style={{ fontSize: 15, color: 'red' }} />
                                                            )
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    }
                                </tbody>
                            </table>
                        </Form>
                    )
                }
            }
        </Formik>
    )
}